﻿import * as $ajax from './_ajax'

export function show(
    meddelande: string,
    close: boolean = true,
    wide: boolean = false,
    wider: boolean = false
) {
    $('#bcfla-modal-text').html(meddelande)

    $('#bcfla-modal').addClass('open')
    $('#bcfla-modal-overlay').addClass('open')

    if (wider) $('#bcfla-modal').addClass('wider')
    else if (wide) $('#bcfla-modal').addClass('wide')

    if (close) $('#bcfla-modal-button-stang').show()
    else $('#bcfla-modal-button-stang').hide()

    $('#bcfla-root').addClass('bcfla-blurrier')
}

export function load(
    url: string,
    data: any = {},
    close: boolean = true,
    wide: boolean = false,
    wider: boolean = false,
    callback: any = null
) {
    $ajax.post({
        url: url,
        data: data,
        dataType: 'html',
        success: function (res) {
            show(res, close, wide, wider)
            if (callback) callback()
        },
    })
}

export function hide() {
    $('#bcfla-modal').removeClass('open')
    $('#bcfla-modal-overlay').removeClass('open')
    $('#bcfla-root').removeClass('bcfla-blurrier')

    // give the modal transition 300 ms to hide the modal before removing wide classes etc, to prevent jumpiness
    setTimeout(function () {
        $('#bcfla-modal').removeClass('wide')
        $('#bcfla-modal').removeClass('wider')
    }, 300)
}

export module imgmodal {
    export function show(imgurl: string) {
        $('#bcfla-imgmodal img').attr('src', imgurl)
        $('#bcfla-imgmodal a').attr('href', imgurl)

        $('#bcfla-imgmodal').addClass('open')
        $('#bcfla-imgmodal-overlay').addClass('open')
    }

    export function hide() {
        $('#bcfla-imgmodal').removeClass('open')
        $('#bcfla-imgmodal-overlay').removeClass('open')
    }
}
